import PropTypes from 'prop-types';
import { useParams, Navigate, generatePath, useLocation } from 'react-router-dom';

export default function SmartNavigate({ to, params = {}, ...props }) {
  const { pathname } = useLocation();
  const currentParams = useParams();
  const toLocation = generatePath(to, { ...currentParams, ...params });

  if (pathname === toLocation) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return <Navigate {...props} to={toLocation} />;
}

SmartNavigate.propTypes = {
  ...Navigate.propTypes,
  params: PropTypes.shape({}),
};
